import React from 'react';
import { Box } from '@mui/material';
import { MuiIconButton } from '@ui/base_library';
import Typography from '@ui/Typography';
import palette from '@ui/palette';
import { makeStyles } from 'tss-react/mui';
import Icon, { IconType } from '@ui/Icon';
import { formatFileSize } from '../utils';

const useStyles = makeStyles()(theme => ({
  filePreviewContent: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 16,
    width: 116,
    padding: 12,
    borderRadius: 4,
  },
  fileBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 8px',
    borderRadius: 4,
    backgroundColor: '#0E2617', // mint-700 (no @ui/palette token defined for this shade)
    border: `1px solid ${palette.mint_600}`,
  },
  fileInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    textAlign: 'center',
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '200px',
  },
  fileSize: {
    color: palette.gray_75,
    fontSize: '12px',
  },
  closeButton: {
    position: 'absolute',
    top: -4,
    right: -4,
    color: 'white',
    zIndex: 1,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
}));

type FilledZoneProps = {
  fileName: string;
  fileSize: number;
  disabled: boolean;
  handleRemoveFile: () => void;
};

const FilledZone = ({
  fileName,
  fileSize,
  disabled,
  handleRemoveFile,
}: FilledZoneProps) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.filePreviewContent}>
      <MuiIconButton
        className={classes.closeButton}
        onClick={handleRemoveFile}
        size="small"
      >
        <Icon type={IconType.close} />
      </MuiIconButton>
      <Box className={classes.fileBadge}>
        <Icon
          type={IconType.file06_1}
          style={{ width: 32, height: 32 }}
          htmlColor={disabled ? palette.gray_400 : palette.mint_400}
        />
      </Box>
      <Box className={classes.fileInfo}>
        <Typography
          variant="h4"
          color={disabled ? 'tertiary' : 'primary'}
          bold
          className={classes.fileName}
        >
          {fileName}
        </Typography>
        <Typography
          variant="pSm"
          color={disabled ? 'tertiary' : 'primary'}
          className={classes.fileSize}
        >
          {formatFileSize(fileSize)}
        </Typography>
      </Box>
    </Box>
  );
};

export default FilledZone;
